import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-form-checkbox',
  templateUrl: './form-checkbox.component.html',
  styleUrls: ['./form-checkbox.component.scss']
})
export class FormCheckboxComponent implements OnInit, OnChanges {
  @Input() checkboxName: string = `v6-${Math.random().toString(36).slice(2)}`;

  @Input() includeFormGroup: boolean = false;

  @Input() label: string

  @Input() helpText: string;

  @Input() model: boolean;

  @Output() modelChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() change:  EventEmitter<any> = new EventEmitter<any>();

  inputValue: boolean;

  constructor() { }

  ngOnInit(): void {
    this.assignFormInputValue();
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes.model){
      this.assignFormInputValue();
    }
  }

  assignFormInputValue() {
    this.inputValue = this.model;
  }

  updateFormInputValue() {
    this.modelChange.emit(this.inputValue);
    this.change.emit(this.inputValue);
  }
}
